import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'app/app.reducer';
import { CategoryResponse } from 'app/models';
import { loadCategoriesSuccess } from 'app/redux/actions';
import { find } from 'lodash';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { CategoryService } from './category.service';

@Injectable({
  providedIn: 'root',
})
export class UserLabelService {
  private categories: CategoryResponse[] = [];

  constructor(
    private categoryService: CategoryService,
    private store: Store<AppState>
  ) {
    this.store.select('category').subscribe(({ categories }) => {
      this.categories = categories || [];
    });
  }

  public getLabel(name: string, projectId: number): Observable<CategoryResponse | null> {
    const cachedLabel = this.findLabel(name);
    if (cachedLabel || !projectId) {
      return of(cachedLabel || null);
    }

    return this.categoryService.getCategoriesOfProjects(projectId).pipe(
      tap((categories: CategoryResponse[]) => {
        this.store.dispatch(loadCategoriesSuccess({ categories }));
      }),
      map((categories: CategoryResponse[]) => this.findLabel(name, categories) || null)
    );
  }

  private findLabel(
    name: string,
    categories: CategoryResponse[] = this.categories
  ): CategoryResponse | undefined {
    return find(
      categories,
      (category) => String(category.name).toLowerCase() === name.toLowerCase()
    );
  }
}
